"use strict";
/* eslint-disable no-param-reassign */
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = isCommonPassword;
/*
 * A list of commonly used passwords.
 */
const common_passwords = [
    "qwer1234",
    "asdfjklø",
    "åpoiqwer",
    "qweriopå",
    "12345678",
    "123456789",
    "1234567890",
    "zxcvbnm,",
    "incorrect",
    "trustno1",
    "rush2112",
    "jordan23",
    "password!",
    "password",
    "password1",
    "abcd1234",
    "blink182",
    "liverpool",
    "ncc1701d",
    "michael1",
    "letmein1",
    "charlie1",
    "qwerty12",
    "mustang1",
    "q1w2e3r4",
    "metallica",
    "access14",
    "asdf1234",
    "wrinkle1",
    "ncc1701e",
    "babylon5",
    "yankees1",
    "jessica1",
    "letmein2",
    "hello123",
    "fuckyou2",
    "freedom1",
    "microsoft",
    "welcome1",
    "passwor1",
    "william1",
    "matthew1",
    "qwertyuiop",
    "asdfghjkl",
    "spiderman",
    "basketball",
    "satan666",
    "thunder1",
    "heather1",
    "anthony1",
    "turkey50",
    "porsche9",
    "chelsea1",
    "webmaster",
    "fuckyou1",
    "a1b2c3d4",
    "richard1",
    "swordfish",
    "ncc1701a",
    "formula1",
    "scooter1",
    "raiders1",
    "front242",
    "qwer1234",
    "cowboys1",
    "gateway1",
    "jackson1",
    "phoenix1",
    "diamond1",
    "patrick1",
    "newpass6",
    "zaq12wsx",
    "wolverine",
    "melissa1",
    "marcius2",
    "rangers1",
    "gandalf1",
    "insertion",
    "temptress",
    "celebrity",
    "streaming",
    "pertinant",
    "pool6123",
    "gordon24",
    "fantasies",
    "businessbabe",
    "brandon1",
    "pa55word",
    "contortionist",
    "test1234",
    "cheerleaers",
    "housewifes",
    "seductive",
    "andyod22",
    "experienced",
    "passwords",
    "close-up",
    "testing1",
    "gallaries",
    "lockerroom",
    "homepage-",
    "fordf150",
    "pa55w0rd",
    "housewife",
    "thumbnils",
    "apollo13",
    "happy123",
    "knickerless",
    "nwo4life",
    "enterprise",
    "misfit99",
    "scandinavian",
    "shannon1",
    "techniques",
    "manchester",
    "chicago1",
    "ferrari1",
    "butterfly",
    "earthlink",
    "films+pic+galeries",
    "girfriend",
    "uncencored",
    "arsenal1",
    "bulldog1",
    "james007",
    "gymnastic",
    "panther1",
    "wp2003wp",
    "jasmine1",
    "pass1234",
    "insertions",
    "marino13",
    "america1",
    "chicken1",
    "r2d2c3po",
    "wonderboy",
    "fishing1",
    "packers1",
    "chester1",
    "charles1",
    "skywalker",
    "florida1",
    "ursitesux",
    "just4fun",
    "rebecca1",
    "newyork1",
    "digipost",
    "digital1",
    "dolphin1",
    "porsche1",
    "stonecold",
    "scorpio1",
    "rt6ytere",
    "madison1",
    "tiffany1",
    "password2",
    "vikings1",
    "quant4307s",
    "michael2",
    "nemrac58",
    "kcj9wx5n",
    "iloveyou1",
    "summer99",
    "monster1",
    "playboy1",
    "captain1",
    "genesis1",
    "jamesbond",
    "maxwell1",
    "care1839",
    "crystal1",
    "broncos1",
    "winston1",
    "warrior1",
    "iloveyou2",
    "cbr900rr",
    "amsterdam",
    "football1",
    "myspace1",
    "spencer1",
    "drummer1",
    "private1",
    "corvet07",
    "iverson3",
    "johnson1",
    "fuckoff1",
    "hotmail1",
    "kordell1",
    "jackson5",
    "rainbow6",
    "qwerty123",
    "hotmail0",
    "hawaii50",
    "southpark",
    "windows1",
    "vincent1",
    "tottenham",
    "yankees2",
    "barcelona",
    "stoppedby",
    "perfect1",
    "cezer121",
    "pantera1",
    "qwert123",
    "nascar24",
    "sunshine",
    "mazdarx7",
    "dodgers1",
    "mustang6",
    "monkey12",
    "birthday4",
    "stephen1",
    "soccer10",
    "starcraft",
    "soccer12",
    "voyager1",
    "success1",
    "password9",
    "apple123",
    "green123",
    "cartman1",
    "favorite6",
    "sabrina1",
    "devil666",
    "paintball",
    "rainbow1",
    "abc12345",
    "wg8e3wjf",
    "gladiator",
    "cricket1",
    "penguin1",
    "anthony7",
    "cameron1",
    "postov1000",
    "buffalo1",
    "peaches1",
    "jupiter1",
    "austin31",
    "chevrolet",
    "f00tball",
    "gateway2",
    "trouble1",
    "cygnusx1",
    "natalie1",
    "yamahar1",
    "snowboard",
    "playboy2",
    "gizmodo1",
    "birthday1",
    "beatles1",
    "mercury1",
    "charlie123",
    "zachary1",
    "superstar",
    "pinkfloyd",
    "csfbr5yy",
    "ncc74656",
    "houston1",
    "idontknow",
    "phantom1",
    "sanity72",
    "bubba123",
    "eclipse1",
    "mustang2",
    "skipper1",
    "therock1",
    "tiger123",
    "frankie1",
    "qazwsxedc",
    "death666",
    "zaq1xsw2",
    "yy5rbfsc",
    "special1",
    "patches1",
    "mash4077",
    "baseball1",
    "favorite2",
    "gfxqx686",
    "dilbert1",
    "pumpkin1",
    "trinity1",
    "trooper1",
    "bubbles1",
    "year2005",
    "spartan1",
    "stanley1",
    "mazda626",
    "primetime21",
    "abcdefg1",
    "buddy123",
    "money123",
    "jackass1",
    "blackjack",
    "melanie1",
    "b929ezzh",
    "ptfe3xxp",
    "access99",
    "claudia1",
    "dapzu455",
    "yqlgr667",
    "zxcvbnm1",
    "basebal1",
    "gabriel1",
    "destiny1",
    "trumpet1",
    "nirvana1",
    "isacs155",
    "letmein22",
    "allison1",
    "fatluvr69",
    "general1",
    "dragon69",
    "dragonball",
    "hihje863",
    "express1",
    "mustang5",
    "iloveyou!",
    "slimed123",
    "ffvdj474",
    "scoobydoo",
    "highlander",
    "kristin1",
    "montana1",
    "blue1234",
    "playstation",
    "jo9k2jw2",
    "jupiter2",
    "marines1",
    "alpha123",
    "gsxr1000",
    "gregory1",
    "gnasher23",
    "save13tx",
    "russell1",
    "dragon12",
    "vanessa1",
    "vampire1",
    "hzze929b",
    "excalibur",
    "mounta1n",
    "stewart1",
    "summer69",
    "ssptx452",
    "master12",
    "flyers88",
    "qcmfd454",
    "undertaker",
    "yvtte545",
    "sooners1",
    "mwq6qlzo",
    "skeeter1",
    "thumper1",
    "tmjxn151",
    "pxx3eftp",
    "chris123",
    "natasha1",
    "nancy123",
    "newcastle",
    "winter99",
    "iqzzt580",
    "1q2w3e4r5t",
    "shadow12",
    "soccer11",
    "pimpdaddy",
    "lincoln1",
    "arizona1",
    "samsung1",
    "dreamer1",
    "paladin1",
    "panasonic",
    "dad2ownu",
    "huskers1",
    "england1",
    "wrinkle5",
    "rasta220",
    "charlie2",
    "cardinals",
    "fortune12",
    "ozlq6qwm",
    "prelude1",
    "dreamweaver",
    "Jeg så en knallbra film i går",
    "Jegasåaenaknallbraafilmaiagår",
    "abcdefghijklmnopqrstuvwxyz",
    "abcdefghijklmnopqrstuvwxyzæøå",
    "qwertyuiopå",
    "asdfghjkløæ",
    "asdfghjklø",
    "asdfghjkløæ'",
    "asdfghjkløæ@",
    "zxcvbnm,.-",
    "1234567890+",
    "'1234567890",
    "'1234567890+",
    "\\|1234567890+",
];
/*
 * A list of common password letter replacements.
 */
const l33t = {
    a: "[a4@]",
    b: "[b8]",
    c: "[c\\(\\{\\[\\<]",
    e: "[e3]",
    g: "[g69]",
    i: "[i1!\\|]",
    l: "[l1\\|7]",
    o: "[o0]",
    s: "[s\\$5]",
    t: "[t\\+7]",
    x: "[x\\%]",
    z: "[z2]",
};
/*
 * Check if a password is in the list of common passwords,
 * or if the password uses common letter replacements.
 */
function isCommonPassword(input) {
    const _leet = [];
    common_passwords.forEach(function (pw) {
        Object.keys(l33t).forEach(function (key) {
            const val = l33t[key];
            pw = pw.replace(new RegExp(key, "g"), val);
        });
        _leet.push(new RegExp(`^${pw}$`, "i"));
    });
    const matches = _leet.filter(function (p) {
        return p.test(input);
    });
    return matches && matches.length > 0;
}
//# sourceMappingURL=commonPasswords.js.map